module.exports = __webpack_public_path__ + "media/img/logo_carQ_yanosik_wybrane_2-03(1)-1bcd8183.png";